export const routesApp = {
    home: '',
    registration: '/registration/step/:stepNumer',
    registrationV2: '/registrationV2/step/:stepNumer',
    registrationV3: '/registrationV3/step/:stepNumer',
    registrationV4: '/registrationV4/step/:stepNumer',
    browse: '/browse',
    messages: '/messages',
    chat: '/messages/chat/:id',
    liked: '/liked',
    settings: '/profile/settings',
    profile: '/profile',
    subscription: '/profile/subscription',
    profileEdit: '/profile/edit',
    profileView: '/profile-view/:id',
    termsOfService: '/profile/terms-of-service',
    banned: '/banned',
    myFormPreview: '/profile/my-form-preview',
} as const;
